import { OptionWithValues, useProductOptions } from '@shopify/hydrogen'
import { ChangeEvent, useContext, useEffect } from 'react'
import styles from '../../assets/scss/components/products/product-option.module.scss'
import { useI18n } from '../i18n.client'
import { ProductLayoutContext } from './product-layout-provider.client'

export const ProductOptions: React.FC = () => {
  const { options } = useProductOptions()

  return (
    <>
      {(options as OptionWithValues[]).map((option) => (
        <ProductOption key={option.name} option={option} />
      ))}
    </>
  )
}

const ProductOption: React.FC<{ option: OptionWithValues }> = ({ option: { name, values } }) => {
  const [i18n] = useI18n()
  const { selectedOptions, setSelectedOption } = useProductOptions()
  const { isTouched, setIsTouched } = useContext(ProductLayoutContext)

  useEffect(() => {
    if (values.length === 1) {
      setIsTouched(true)
    }
  }, [values])

  if (values.length === 1) {
    return null
  }

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    setSelectedOption(name, event.target.value)
    setIsTouched(true)
  }

  return (
    <div className={styles.productOption}>
      <select className={styles.select} onChange={handleChange}>
        <option>{i18n.translate('select-option', { option: name })}</option>
        {values.map((value) => (
          <ProductOptionValue value={value} />
        ))}
      </select>
      <div className={styles.value}>
        {isTouched && selectedOptions ? selectedOptions[name] : i18n.translate('select-option', { option: name })}
      </div>
    </div>
  )
}

const ProductOptionValue: React.FC<{ value: string }> = ({ value }) => {
  const [i18n] = useI18n()
  const { variants } = useProductOptions()
  const isOutOfStock = !variants?.find((variant) => value === variant?.title)?.availableForSale

  return (
    <option key={value} value={value}>
      {value}
      {isOutOfStock && ` (${i18n.translate('sold-out')})`}
    </option>
  )
}
